const runAction = async (action, params) => {
    return BX.ajax
        .runAction("evraz:main.delivery." + action, { data: params })
        .then((res) => res.data);
};

/**
 * Подсказки для адреса доставки
 * @param options.inputText Текст ввода
 * @param options.cityKladr kladr_id города
 * @param options.count кол-во элементов
 * @returns {Promise<T | *[]>}
 */
export const querySuggestions = async (options) => {
    if (!options.count) {
        options.count = 10; // по умолчанию 10
    }
    if (!options.cityKladr) {
        delete options.cityKladr; // чтобы не передавалось undefined
    }
    const response = await runAction("suggestions", { options })
        .then((data) => {
            let suggestions = data.suggestions;
            if (Array.isArray(suggestions)) {
                /** Переименование .value в .addressText,
                 * чтобы suggestions имели вид: [{addressText: адрес, data: {данные}}] */
                suggestions = suggestions.map((el) => ({
                    addressText: el.data.country + ', ' + el.value,
                    data: el.data,
                })).filter((el) => {
                    return !el.data.flat;
                });
                // console.log("suggestions", suggestions);
                return suggestions;
            } else {
                console.error(
                    "suggestions ожидались в виде [{addressText: адрес, data: {данные}}], пришло:",
                    data
                );
                return [];
            }
        })
        .catch((e) => {
            console.error(e);
            return [];
        });

    return response;
};
